/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 MenuItem — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: minHeight 36 i.p.v. MUI 48 (compacter zoals Tractie list-pattern).
// padding-inline 12 (Tractie inset-s, consistent met Chip label).
// transition: none (ground-rules.md "Motion and text": geen animatie). selected backgroundColor via NS subtle-bg.

export const MuiMenuItemLightOverrides = {
  root: {
    minHeight: 36,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 12,
    boxSizing: 'border-box' as const,
    width: 'auto',
    overflow: 'hidden' as const,
    whiteSpace: 'nowrap' as const,
    color: 'var(--ns-color-fg-default)',
    transition: 'none',
    '&$selected': {
      backgroundColor: 'var(--ns-color-bg-emphasis-secondary)',
    },
    '&$selected:hover': {
      backgroundColor: 'var(--ns-color-bg-emphasis-secondary)',
    },
    '&:hover': {
      backgroundColor: 'var(--ns-color-bg-emphasis-secondary)',
    },
  },

  // Pseudo-class hook — wordt via root gestyled.
  gutters: {},
  selected: {},

  dense: {
    minHeight: 32,
    paddingTop: 4,
    paddingBottom: 4,
  },
} as const;

// Dark variant — alle kleur-tokens zijn mode-aware via tokens.css.
export const MuiMenuItemDarkOverrides = {
  ...MuiMenuItemLightOverrides,
} as const;
